
import { useCallback, useEffect, useState } from "react"
import { useAppSelector } from "@hooks/store"
import { Form } from "antd"
import { getChargeLateFeeTypes } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/services/GET/getChargeLateFeeTypes"
import { useNewEditTemplateCollectionContext } from "@pages/collectionAdministration/pages/NewEditTemplateCollection/context/NewEditTemplateCollectionContext"

export const useArrearsModal = ({ handleOpenCloseModal, isOpenModal }) => {
    //Usar un contexto tanto para traer los datos del cargo si existen como para guardarlos
    const { idToken, currencySymbol } = useAppSelector(state => state.auth)
    const { chargeDetail, buttonsArrearsOptions, setButtonsArrearsOptions, setChargeDetail, setHasUnsavedChanges } = useNewEditTemplateCollectionContext()
    const [form] = Form.useForm()

    const [isSingleCode, setIsSingleCode] = useState("percentage")

    const getRecurrencyOptions = useCallback(async () => {
        const res = await getChargeLateFeeTypes({ token: idToken })

        setButtonsArrearsOptions(res.data.data.map((item) => ({
            id: item?.charge_late_fee_type_id,
            code: item?.code,
            name: item?.name
        })))

        const defaultValues = {
            charge_late_fee_type_code: res.data.data.find((item) => item?.charge_late_fee_type_id === chargeDetail.late_fee.metadata?.charge_late_fee_type_id)?.code
                ?? 'percentage',
            charge_late_fee_type_id: res.data.data.find((item) => item?.charge_late_fee_type_id === chargeDetail.late_fee.metadata?.charge_late_fee_type_id)?.charge_late_fee_type_id
                ?? res.data.data.find((item) => item?.code === 'percentage')?.charge_late_fee_type_id,
            value: chargeDetail.late_fee.metadata?.value ?? null
        }
        setIsSingleCode(!defaultValues.charge_late_fee_type_code  ? 'percentage' : defaultValues.charge_late_fee_type_code)
        
        form.setFieldsValue({
            ...defaultValues
        })

    }, [form, idToken, chargeDetail, setButtonsArrearsOptions])

    const handleChangeRecurrenceMethod = ({ code, value }) => {
        setIsSingleCode(code)
        form.setFieldsValue({
            charge_late_fee_type_code: code,
            charge_late_fee_type_id: value
        })
        if (code === 'percentage') {
            form.setFieldsValue({
                value: 1
            })
        }
    }

    const handleSaveRecurrence = async ({ values }) => {
        setChargeDetail(prev => ({
            ...prev,
            late_fee: {
                ...prev.late_fee,
                metadata: {
                    ...prev.late_fee.metadata,
                    ...values
                }
            }
        }))
        setHasUnsavedChanges(true)
        //Cerrar el modal
        handleOpenCloseModal({ isOpenModal: false })
    }

    useEffect(() => {
        if (!isOpenModal) return
        getRecurrencyOptions()

    }, [getRecurrencyOptions, isOpenModal])

    return {
        form,
        buttonsArrearsOptions,
        isSingleCode,
        currencySymbol,
        handleSaveRecurrence,
        handleChangeRecurrenceMethod
    }
}